/**
 * Polyfill cho crypto.randomUUID() để tương thích với các trình duyệt cũ
 * Tạo UUID v4 ngẫu nhiên
 */
export function generateUUID(): string {
  // Kiểm tra nếu trình duyệt hỗ trợ crypto.randomUUID()
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }

  // Polyfill cho các trình duyệt cũ
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * Tạo unique ID đơn giản hơn nếu không cần UUID format
 */
export function generateUniqueId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }

  // Fallback đơn giản hơn
  return Date.now().toString(36) + Math.random().toString(36).substr(2)
}
